import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import debounce from "lodash/debounce";
import { useField } from "react-final-form";
import { SuggestedInput } from "@vk-hr-tek/ui/input";
import { compose } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function SuggestedInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else SuggestedInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const SuggestedInput_SuggestedInput = (props)=>{
    const $ = c(67);
    let debounceTimeout;
    let helperText;
    let label;
    let labelIcon;
    let mask;
    let name;
    let onChange;
    let placeholder;
    let renderOption;
    let rest;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let tooltip;
    let type;
    let validate;
    if ($[0] !== props) {
        ({ type, name, label, labelIcon, onChange, placeholder, disabled: t0, required: t1, clearable: t2, loading: t3, tooltip, helperText, renderOption, limit: t4, minInputValueLength: t5, mask, validate, validationWithoutTouch: t6, validationWhenDisabled: t7, debounceTimeout } = props), rest = _object_without_properties(props, [
            "type",
            "name",
            "label",
            "labelIcon",
            "onChange",
            "placeholder",
            "disabled",
            "required",
            "clearable",
            "loading",
            "tooltip",
            "helperText",
            "renderOption",
            "limit",
            "minInputValueLength",
            "mask",
            "validate",
            "validationWithoutTouch",
            "validationWhenDisabled",
            "debounceTimeout"
        ]);
        $[0] = props;
        $[1] = debounceTimeout;
        $[2] = helperText;
        $[3] = label;
        $[4] = labelIcon;
        $[5] = mask;
        $[6] = name;
        $[7] = onChange;
        $[8] = placeholder;
        $[9] = renderOption;
        $[10] = rest;
        $[11] = t0;
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = tooltip;
        $[20] = type;
        $[21] = validate;
    } else {
        debounceTimeout = $[1];
        helperText = $[2];
        label = $[3];
        labelIcon = $[4];
        mask = $[5];
        name = $[6];
        onChange = $[7];
        placeholder = $[8];
        renderOption = $[9];
        rest = $[10];
        t0 = $[11];
        t1 = $[12];
        t2 = $[13];
        t3 = $[14];
        t4 = $[15];
        t5 = $[16];
        t6 = $[17];
        t7 = $[18];
        tooltip = $[19];
        type = $[20];
        validate = $[21];
    }
    const disabled = void 0 === t0 ? false : t0;
    const required = void 0 === t1 ? false : t1;
    const clearable = void 0 === t2 ? false : t2;
    const loading = void 0 === t3 ? false : t3;
    const limit = void 0 === t4 ? 50 : t4;
    const minInputValueLength = void 0 === t5 ? 1 : t5;
    const validationWithoutTouch = void 0 === t6 ? false : t6;
    const validationWhenDisabled = void 0 === t7 ? false : t7;
    let t8;
    if ($[22] !== validate) {
        t8 = Array.isArray(validate) ? compose(validate) : validate;
        $[22] = validate;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== rest || $[25] !== t8) {
        t9 = _object_spread({
            validate: t8
        }, rest);
        $[24] = rest;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    const fieldProps = useField(name, t9);
    const { input, meta } = fieldProps;
    const { onChange: onInputChange } = input;
    const [value, setValue] = useState(input.value);
    let t10;
    if ($[27] !== onChange || $[28] !== onInputChange) {
        t10 = (formValue)=>{
            onInputChange(formValue);
            if (onChange) onChange(formValue);
        };
        $[27] = onChange;
        $[28] = onInputChange;
        $[29] = t10;
    } else t10 = $[29];
    const handleChangeForm = t10;
    let t11;
    if ($[30] !== debounceTimeout || $[31] !== handleChangeForm) {
        t11 = debounce(handleChangeForm, debounceTimeout);
        $[30] = debounceTimeout;
        $[31] = handleChangeForm;
        $[32] = t11;
    } else t11 = $[32];
    const handleChangeDebounce = t11;
    let t12;
    let t13;
    if ($[33] !== handleChangeDebounce) {
        t12 = ()=>()=>{
                handleChangeDebounce.flush();
            };
        t13 = [
            handleChangeDebounce
        ];
        $[33] = handleChangeDebounce;
        $[34] = t12;
        $[35] = t13;
    } else {
        t12 = $[34];
        t13 = $[35];
    }
    useEffect(t12, t13);
    let t14;
    if ($[36] !== debounceTimeout || $[37] !== handleChangeDebounce || $[38] !== handleChangeForm) {
        t14 = (changedValue)=>{
            setValue(changedValue);
            if (debounceTimeout) {
                handleChangeDebounce(changedValue);
                if ("" === changedValue) handleChangeForm(changedValue);
            } else handleChangeForm(changedValue);
        };
        $[36] = debounceTimeout;
        $[37] = handleChangeDebounce;
        $[38] = handleChangeForm;
        $[39] = t14;
    } else t14 = $[39];
    const handleChange = t14;
    const errorDisabled = disabled || !validationWhenDisabled;
    const renderError = !errorDisabled && validationWithoutTouch ? !!input.value && !!meta.error : meta.touched && !!meta.error;
    const t15 = renderError && meta.error || helperText;
    let t16;
    if ($[40] !== clearable || $[41] !== disabled || $[42] !== handleChange || $[43] !== input || $[44] !== label || $[45] !== labelIcon || $[46] !== limit || $[47] !== loading || $[48] !== minInputValueLength || $[49] !== placeholder || $[50] !== renderOption || $[51] !== required || $[52] !== t15 || $[53] !== tooltip || $[54] !== type) {
        t16 = _object_spread_props(_object_spread({}, input), {
            type,
            label,
            labelIcon,
            onChange: handleChange,
            placeholder,
            disabled,
            required,
            clearable,
            loading,
            tooltip,
            helperText: t15,
            renderOption,
            limit,
            minInputValueLength
        });
        $[40] = clearable;
        $[41] = disabled;
        $[42] = handleChange;
        $[43] = input;
        $[44] = label;
        $[45] = labelIcon;
        $[46] = limit;
        $[47] = loading;
        $[48] = minInputValueLength;
        $[49] = placeholder;
        $[50] = renderOption;
        $[51] = required;
        $[52] = t15;
        $[53] = tooltip;
        $[54] = type;
        $[55] = t16;
    } else t16 = $[55];
    const commonInputProps = t16;
    if ("load" === type) {
        const t17 = value || input.value;
        let t18;
        if ($[56] !== commonInputProps || $[57] !== mask || $[58] !== props.loadItems || $[59] !== renderError || $[60] !== t17) {
            t18 = /*#__PURE__*/ jsx(SuggestedInput, _object_spread_props(_object_spread({}, commonInputProps), {
                value: t17,
                type: "load",
                loadItems: props.loadItems,
                mask: mask,
                error: renderError
            }));
            $[56] = commonInputProps;
            $[57] = mask;
            $[58] = props.loadItems;
            $[59] = renderError;
            $[60] = t17;
            $[61] = t18;
        } else t18 = $[61];
        return t18;
    }
    const t17 = value || input.value;
    const t18 = meta.touched && !!meta.error;
    let t19;
    if ($[62] !== commonInputProps || $[63] !== props.externalItems || $[64] !== t17 || $[65] !== t18) {
        t19 = /*#__PURE__*/ jsx(SuggestedInput, _object_spread_props(_object_spread({}, commonInputProps), {
            value: t17,
            type: "local",
            externalItems: props.externalItems,
            error: t18
        }));
        $[62] = commonInputProps;
        $[63] = props.externalItems;
        $[64] = t17;
        $[65] = t18;
        $[66] = t19;
    } else t19 = $[66];
    return t19;
};
export { SuggestedInput_SuggestedInput as SuggestedInput };
